module.exports = __webpack_public_path__ + "f3aca93066d593c71468509d16a566cd.ttf";